import React from 'react';
import PropTypes from 'prop-types';

import { DECLINED, DECLINED_ALT } from 'constants/orderStatuses';

import { getItemStatusClassName } from 'helpers/MyAccountRenderUtils';

const OrderStatus = ({ order: { statuses, orderId } }, { testId }) => {
  const statusArr = [];
  const standardizeOrderStatus = status => {
    if (status === DECLINED_ALT) { // 'Declined'
      return DECLINED; // 'Customer Action Required'
    }
    return status;
  };

  statuses.map((status, i) => {
    status = status.toLowerCase();
    statusArr.push(
      <span
        key={`${orderId}_${i}`}
        data-test-id={testId('orderStatus')}
        className={getItemStatusClassName(status)}>{standardizeOrderStatus(status)}</span>
    );
  });
  return <>{statusArr}</>;
};

OrderStatus.propTypes = {
  order: PropTypes.object.isRequired
};

OrderStatus.contextTypes = {
  testId: PropTypes.func
};

export default OrderStatus;
